/* eslint-disable max-classes-per-file */
import get from 'lodash/get';

class Schema {
  constructor(importTheme) {
    this.importTheme = importTheme;
  }

  getAsync = () => {
    this.promise = this.importTheme();
    this.getAsync = () => this.promise;
    return this.promise;
  };

  promise = null;
}

const mapSchemas = {
  all_black: {
    1: new Schema(() =>
      import(/* webpackChunkName: "Schemas/contrast-1-all_black" */ '@Styles/schemas/contrast-1-all_black.scss')
    ),
    2: new Schema(() =>
      import(/* webpackChunkName: "Schemas/contrast-2-all_black" */ '@Styles/schemas/contrast-2-all_black.scss')
    ),
    3: new Schema(() =>
      import(/* webpackChunkName: "Schemas/contrast-3-all_black" */ '@Styles/schemas/contrast-3-all_black.scss')
    ),
    4: new Schema(() =>
      import(/* webpackChunkName: "Schemas/contrast-4-all_black" */ '@Styles/schemas/contrast-4-all_black.scss')
    ),
  },
  default: {
    // Include defaultSchema in bundle to prevent broken styles while first loaded
    1: new Schema(() => import('@Styles/schemas/defaultSchema.scss')),
    2: new Schema(() =>
      import(/* webpackChunkName: "Schemas/contrast-2-default" */ '@Styles/schemas/contrast-2-default.scss')
    ),
    3: new Schema(() =>
      import(/* webpackChunkName: "Schemas/contrast-3-default" */ '@Styles/schemas/contrast-3-default.scss')
    ),
    4: new Schema(() =>
      import(/* webpackChunkName: "Schemas/contrast-4-default" */ '@Styles/schemas/contrast-4-default.scss')
    ),
  },
};

const defaultSchema = mapSchemas.default[1];
const pagePendingElement = document.querySelector('#page-pending');
const checkMainContentElementNotEmpty = () => {
  const contentElement = document.querySelector('[ui-view]');
  return contentElement && contentElement.textContent.trim().length > 0;
};
let mainContentLoadedPromise;

const checkMainContentLoadedPromise = () => {
  if (!mainContentLoadedPromise) {
    mainContentLoadedPromise = new Promise((resolve) => {
      // TODO Revise this approach after React routing implemented
      // If content is already loaded, resolve immediately
      if (checkMainContentElementNotEmpty()) {
        resolve();
        return;
      }

      // If content is not loaded, create mutation observer and wait for it
      const mainContentMutationObserver = new MutationObserver(() => {
        if (checkMainContentElementNotEmpty()) {
          resolve();
          mainContentMutationObserver.disconnect();
        }
      });

      mainContentMutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  return mainContentLoadedPromise;
};

class SchemasService {
  defaultSchema = defaultSchema;

  currentSchema = null;

  hidePagePending = () => {
    pagePendingElement.classList.add('rx-loader--container__hidden');
    document.body.classList.remove('hidden-overflow');
  };

  getTheme = (fontColor, contrast) => get(mapSchemas, `${fontColor}.${contrast}`, defaultSchema);

  async applySchema(fontColor, contrast) {
    const schema = this.getTheme(fontColor, contrast);

    if (this.currentSchema !== schema) {
      await this.replaceCurrentSchema(schema);
    }
    await checkMainContentLoadedPromise();

    this.hidePagePending();
  }

  async replaceCurrentSchema(newSchema) {
    const oldSchema = this.currentSchema;
    this.currentSchema = newSchema;

    const newSchemaAsync = await newSchema.getAsync();

    if (newSchemaAsync.use) {
      newSchemaAsync.use();
    }

    if (oldSchema) {
      const oldSchemaAsync = await oldSchema.getAsync();

      if (oldSchemaAsync.unuse) {
        oldSchemaAsync.unuse();
      }
    }
  }
}

export default new SchemasService();
